import { useDispatch } from 'react-redux';
import { showFlashDiv, hideFlashDiv } from 'components/flash/flash.action';
import { FlashTypes } from '__utils/type';


const useFlashToggler = () => {
    const dispatch = useDispatch();
    const flash = function () {
        return {
            success: function (message: string, time = 3000, successCallBack?: Function) {
                dispatch(showFlashDiv({ type: FlashTypes.SUCCESS, message: message }));
                setTimeout(() => {
                    dispatch(hideFlashDiv());
                    successCallBack && successCallBack();
                }, time);
            },
            error: function (message: string, time = 3000, failureCallBack?: Function) {
                dispatch(showFlashDiv({ type: FlashTypes.ERROR, message: message }));
                setTimeout(() => {
                    dispatch(hideFlashDiv());
                    failureCallBack && failureCallBack();
                }, time);
            },
            hide: function () {
                dispatch(hideFlashDiv());
            }
        }
    }();
    return flash;
};

export default useFlashToggler;
